"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsInternal = void 0;
const storage_1 = __importDefault(require("./storage"));
let internal;
const useIsInternal = () => {
    if (internal !== undefined) {
        return internal;
    }
    const { host } = window.location;
    if (host.includes('preview.') ||
        host.includes('dev.') ||
        host.includes('canary.') ||
        /^pr\d+\./i.test(host) ||
        host.includes('tools.modernatx.com')) {
        storage_1.default.setItem('MDRNA_PARTNER', '1', 365);
    }
    internal = storage_1.default.getItem('MDRNA_PARTNER') === '1';
    return internal;
};
exports.useIsInternal = useIsInternal;
